function Page404() {
  return (
    <p className="text text_type_main-large mt-20" style={{textAlign: "center"}}>Страница не найдена</p>
  )
}

export default Page404;
